module.exports = __webpack_public_path__ + "media/images/partner_logo-b880ca4a277764f3e357b51642b4a818.png";